<details  #details (focusHover)="showDesktopDropdown(details, $event)">
  <summary role="button" class="dropdown-summary">
    <span *ngIf="isSidebarItem else summaryAsLink">{{ navItem.text }}</span>
    <!-- dropdown can only have external main link at this time -->
    <ng-template #summaryAsLink>
      <a [href]="navItem.url" class="nav-link">{{navItem.text}}</a>
    </ng-template>
    <fa name="chevron-right"></fa>
  </summary>
  <ul class="dropdown-list">
    <li *ngFor="let dropdownItem of navItem.dropdownItems">
      <a *ngIf="dropdownItem.type === 'external'" class="nav-link nav-dropdown-link" [href]="dropdownItem.url">
        <b>{{ dropdownItem.text }}</b>
        <span class="dropdown-item-details">{{ dropdownItem.description }}</span>
      </a>
    <a *ngIf="dropdownItem.type === 'internal'" [routerLink]="dropdownItem.routerLink">
        <b>{{ dropdownItem.text }}</b>
        <span class="dropdown-item-details">{{ dropdownItem.description }}</span>
      </a>
    </li>
  </ul>
</details>

